export default function Error() {
  return (
    <div className="flex w-full h-full items-center justify-center text-center">
      Ошибка загрузки карты, пожалуйста попробуйте перезагрузить страницу
    </div>
  );
}
